<template>
  <navbar
    ref="navBar"
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
 <template>

      <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >        
      </el-popover>
    </template>
    <template slot="navbar-menu">            
      
      <span class="flag-and-currency">
        <img class="flags-top" v-lazy="selectedFlag" />
        <div class="vl"></div>
        <span class="currency-sign">{{selectedCurrencySign}}</span>
      </span>
    
      <div class="compopo-h2">
        <h2>Compopo</h2>
      </div>
      <drop-down tag="li" class="nav-item" title="Ship To">        
        <a class="dropdown-item" @click="countrySelected('AT')">
          <img v-lazy="'img/flags/AT.png'"/>
          Austria
        </a>
        <a class="dropdown-item" @click="countrySelected('BG')">
          <img v-lazy="'img/flags/BG.png'"/>
          Bulgaria
        </a>
        <a class="dropdown-item" @click="countrySelected('FR')">
          <img v-lazy="'img/flags/FR.png'"/>
          France
        </a>
        <a class="dropdown-item" @click="countrySelected('DE')">
          <img v-lazy="'img/flags/DE.png'"/>
          Germany
        </a>
        <a class="dropdown-item" @click="countrySelected('IL')">
          <img v-lazy="'img/flags/IL.png'"/>
          Israel
        </a>
        <a class="dropdown-item" @click="countrySelected('IT')">
          <img v-lazy="'img/flags/IT.png'"/>
          Italy
        </a>
        <a class="dropdown-item" @click="countrySelected('PL')">
          <img v-lazy="'img/flags/PL.png'"/>
          Poland
        </a>
        <a class="dropdown-item" @click="countrySelected('RU')">
          <img v-lazy="'img/flags/RU.png'"/>
          Russia
        </a>
        <a class="dropdown-item" @click="countrySelected('GB')">
          <img v-lazy="'img/flags/GB.png'"/>
          United Kingdom
        </a>
        <a class="dropdown-item" @click="countrySelected('US')">
          <img v-lazy="'img/flags/US.png'"/>
          United States
        </a>                
      </drop-down>                 
      
      <drop-down tag="li" class="nav-item" title="Currency">
        <a class="dropdown-item currency" @click="currencySelected('NIS')">₪ NIS</a>
        <a class="dropdown-item currency" @click="currencySelected('USD')">$ USD</a>
        <a class="dropdown-item currency" @click="currencySelected('EUR')">€ EUR</a>
        <a class="dropdown-item currency" @click="currencySelected('GBP')">£ GBP</a>               
      </drop-down>
      
      <drop-down
              tag="li"
              title="Contact Us"              
              class="nav-item"
      >
        <nav-link to="/support">
          <i class="now-ui-icons objects_support-17"></i> Support
        </nav-link>        
      </drop-down>

      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Like us on Facebook"
          data-placement="bottom"
          href="https://www.facebook.com/Compopo-102102265712707/"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Instagram"
          data-placement="bottom"
          href="https://instagram.com/compopo2021?utm_medium=copy_link"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Check us out on TikTok"
          data-placement="bottom"
          href="https://vm.tiktok.com/ZSeCHbATm/"
          target="_blank"
        >
          <i class="fab fa-tiktok"></i>
          <p class="d-lg-none d-xl-none">TikTok</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    flag: String,
    currency: String   
  },
  components: {
    DropDown,
    Navbar,    
    NavLink,
    [Popover.name]: Popover
  },
  data() {
    return {      
      selectedFlag: `img/flags/${this.flag || 'US'}.png`,
      selectedCurrency: this.currency || 'USD',
      currencyAndSign: {"NIS": "₪", "ILS": "₪", "USD": "$", "EUR": "€", "GBP": "£", "RUB": "₽"},      
      selectedCurrencySign: ""      
    };
  },
  methods: {
    updateNavBar() {      
      this.$refs.navBar.openNavbar();
    },

    countrySelected(country) {      
      this.selectedFlag = "img/flags/" + country + ".png"      
      this.$cookie.set("selectedCountry", country, 365)   
      this.$emit('changed', this.selectedFlag)    
    },

    currencySelected(currency) {
      this.$cookie.set("selectedCurrency", currency, 365)
      this.selectedCurrencySign = this.currencyAndSign[currency]    
      this.$emit('changed')
    }
  },
  
  mounted() {
    //changed
    //this.selectedCurrencySign = this.currencyAndSign[this.selectedCurrency]
    this.selectedCurrencySign = this.currencyAndSign[this.currency]
    
  },

  watch: {
    flag(newVal, oldVal) {
      if (newVal != null) {
        this.selectedFlag = `img/flags/${newVal}.png`;
      }
    },
    currency(newVal, oldVal) {
      if (newVal != null) {
        this.selectedCurrency = newVal;
        this.selectedCurrencySign = this.currencyAndSign[newVal]
      }
    }
  }

};
</script>

<style scoped>

@media screen and (max-width: 991px){
  .flags-top {
    width:  30px !important;
    height: 20px !important;
  }

  .flag-and-currency {    
    display: none;
  }

  .compopo-h2 {
    display: block !important;
    text-align: center;
  }
}

.compopo-h2 {
  display: none;
}

.dropdown-item.currency {
  width: 90px !important;  
} 
.flags-top {
  float: left;
  height: 17px;
  margin-top: 11px;
}

.currency-sign {    
  font-size: 25px;      
}

.vl {
  border-left: 2px solid rgba(255, 255, 255, 0.63);
  height: 16px;
  float: left;  
  margin-left: 4px;  
  margin-right: 4px;
  margin-top: 11px;
}

.flag-and-currency {
  margin-left: 24px;  
}



</style>
